export default __webpack_public_path__ + "static/media/nine_of_wands.a7f2d805.png";